import { motion } from "framer-motion";

export const NoiseOverlay = () => (
  <>
    <div className="evo-noise" aria-hidden="true" />
    <div className="evo-grid-lines" aria-hidden="true" />
  </>
);

const easeOut = [0.16, 1, 0.3, 1];

// Line-by-line masked reveal (used in heroes)
export const MaskReveal = ({ children, delay = 0, className = "" }) => (
  <span className="mask-line">
    <motion.span
      style={{ display: "block" }}
      className={className}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, ease: easeOut, delay }}
    >
      {children}
    </motion.span>
  </span>
);

// Scroll-triggered fade + rise
export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, ease: easeOut, delay }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`text-xs uppercase tracking-[0.25em] text-evo-gold font-medium ${className}`}>
    {children}
  </span>
);
